import { combineReducers } from 'redux';
import user from './user';
import featuredEvent from './featuredEvent';
import featuredPerk from './featuredPerk';

export default combineReducers({
  user,
  featuredEvent,
  featuredPerk,
});
